import { AppContextProps } from "./AppContext";

export class Toast {

  static Show(app_ctx: AppContextProps | null,
    message: string) {
    app_ctx?.ShowToast(message, undefined);
  }

  static ShowDanger(app_ctx: AppContextProps | null, message: string) {
    app_ctx?.ShowToast(message, { variant: 'error' });
  }

  static ShowWarning(app_ctx: AppContextProps | null, message: string) {
    app_ctx?.ShowToast(message, { variant: 'warning' });
  }

  static ShowScuccess(app_ctx: AppContextProps | null, message: string) {
    app_ctx?.ShowToast(message, { variant: 'success' });
  }

  static ShowInfo(app_ctx: AppContextProps | null, message: string) {
    app_ctx?.ShowToast(message, { variant: 'info' });
  }

}
